import { Stack, Title, Text, Button } from '@repletoryreach/sdk-ui';
import { useNavigate } from 'react-router-dom';
import { ForgotForm } from './components/ForgotForm';
import { useT } from '../../../i18n/I18nProvider';

/**
 * Password-recovery entry point.
 *
 * Layout follows `_UI_improvements/tenant/images/auth-forgot-password.png`:
 * a circular icon badge above a centred heading, the single field, then a
 * divider and a full-width route back to sign-in: which used to be a caption
 * link, the smallest element on a page whose whole job is one decision.
 */
export default function ForgotPasswordPage() {
  const t = useT();
  const navigate = useNavigate();
  return (
    <Stack gap="lg">
      <Stack gap="xs" align="center">
        <span className="rr-auth__icon-badge" aria-hidden><MailLockIcon /></span>
        <Title order={1} ta="center">{t('auth.forgot.title')}</Title>
        <Text role="bodySmall" c="var(--rr-color-text-muted)" ta="center">
          {t('auth.forgot.description')}
        </Text>
      </Stack>

      <ForgotForm />

      <div className="rr-auth__divider">{t('auth.common.or')}</div>

      <Button
        variant="default"
        fullWidth
        onClick={() => navigate('/auth/login')}
        leftSection={<ArrowLeftIcon />}
      >
        {t('auth.common.backToSignIn')}
      </Button>
    </Stack>
  );
}

function MailLockIcon() {
  return (
    <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M3 6.5h18v8a1.5 1.5 0 01-1.5 1.5H12" />
      <path d="M3 7l9 6 9-6" />
      <rect x="3" y="16" width="7" height="5.5" rx="1.2" />
      <path d="M4.9 16v-1.6a1.6 1.6 0 013.2 0V16" />
    </svg>
  );
}

function ArrowLeftIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 16 16" fill="none" stroke="currentColor"
      strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M13 8H3" />
      <path d="M6.5 4.5L3 8l3.5 3.5" />
    </svg>
  );
}
